import axios from 'axios'

const KEY = 'AIzaSyBQ0L0bUYbOXrzvm5gHLPk9DBLAX1mKcto'


export default axios.create({
    baseURL: 'https://www.googleapis.com/youtube/v3',
    params: {
        part: 'snippet',
        maxResults: 5,
        key: KEY,
    }
})




